<template>
  <div>
    <section class="hero is-black is-medium has-text-centered is-2 padding-top">
      <div class="hero-body has-background-dark bg-img">
        <div class="container">
          <!-- <h1 class="title is-1 has-text-weight-bold">Discover Nearest Knockout</h1> -->
        </div>
      </div>
      <BrowseZones />
    </section>
    <!-- Branch list -->
    <section class="section has-background-black has-text-white">
      <div class="container">
        <div class="pad-20" v-for="(zone, index) in zones" :key="index" :id="zone.id">
          <h1
            class="title has-text-weight-bold is-uppercase highlight"
            v-if="zone.branches.length"
          >{{zone.name}}</h1>

          <div class="columns is-multiline">
            <div
              class="column location-card is-one-quarter drop-shadow"
              v-for="(branch, index) in zone.branches"
              :key="index"
            >
              <div class="card has-text-light">
                <div class="card-content">
                  <p class="title has-text-white is-size-4 has-text-weight-bold">{{ branch.name }}</p>
                  <p class="has-text-grey-lighter is-size-6 caption">{{branch.address}}</p>
                  <p
                    class="has-text-warning is-size-7 caption is-uppercase has-text-weight-semibold"
                  >{{branch.info}}</p>
                </div>
                <footer class="card-footer is-primary button">
                  <a
                    :href="branch.location"
                    class="card-footer-item is-primary has-text-white"
                    target="_blank"
                  >Open in Maps</a>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <WhatsappCTA />
  </div>
</template>

<script>
import WhatsappCTA from "../components/WhatsappCTA";
import BrowseZones from "../components/Branches/BrowseZones";
export default {
  components: {
    WhatsappCTA,
    BrowseZones
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  data() {
    return {
      zones: [
        {
          name: "East Delhi",
          id: "east-delhi",
          branches: [
            {
              name: "Nehru Enclave",
              location: "https://goo.gl/maps/HBBtRi6K4duAJ5SW8",
              address:
                "R-23, Top Floor, Nehru Enclave, Near Nehru Place Flyover, New Delhi, Delhi 110019",
              state: ""
            },
            {
              name: "Karkardooma",
              address:
                "21, Vigyan Lok, Anand Viha near Cafe Wink, Karkardooma, East Delhi, 110092",
              location: "https://goo.gl/maps/cuXthUdkjs2Y85xH7",
              state: ""
            }
          ]
        },
        {
          name: "West Delhi",
          id: "west-delhi",
          branches: [
            {
              name: "Vishnu Garden",
              address:
                "A-59, Shyam Nagar, Mukerjee Park, Shyam Nagar, Vishnu Garden, Delhi, 110018",
              location: "https://goo.gl/maps/qz6vPkXLfg4dTYSo6",
              state: ""
            }
          ]
        },
        {
          name: "North Delhi",
          id: "north-delhi",
          branches: []
        },
        {
          name: "South Delhi",
          id: "south-delhi",
          branches: [
            {
              name: "Malviya Nagar",
              address:
                "A-233, block-A shivalik, near gol chakkar, malviya Nagar Nearest metro malviya nagar station, Delhi 110017",
              location: "https://goo.gl/maps/KXjMsA5scJGseFDz9",
              state: ""
            },
            {
              name: "Saket",
              address: "E-47 Basement, Near PVR Saket, New Delhi, Delhi",
              location: "https://goo.gl/maps/bjXPije6LmkLih8eA",
              state: ""
            }
          ]
        },
        {
          name: "Delhi NCR",
          id: "delhi-ncr",
          branches: [
            {
              name: "Faridabad",
              address:
                "B 696, 1st & 2nd floor, Gate no.10, Greenfields, Faridabad, Haryana 121010",
              location: "https://goo.gl/maps/YaTg6F9drKjzuath8",
              info: "This route has tolls",
              state: ""
            },
            {
              name: "Gurgaon DLF 3",
              address:
                "H.No. 27, Gali No. 24, T Block, Nathupur Rd, DLF Phase 3, Gurugram, Haryana 122010",
              location: "https://goo.gl/maps/v1PcLV3mVckrBQxt6",
              state: ""
            },
            // {
            //   name: "Gurgaon Sector 58",
            //   address: "",
            //   location: "https://maps.google.com",
            //   state: ""
            // },
            {
              name: "Noida Sector 76",
              address:
                "Amarpali Crystal Home Shopping Arcade, Basement, Sector 76, Noida, Uttar Pradesh 201306",
              location: "https://goo.gl/maps/b7L15DHyKHL3kR889",
              state: ""
            }
            // {
            //   name: "Noida Extension Gaur City",
            //   address: "",
            //   location: "https://maps.google.com",
            //   state: ""
            // }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.bg-img {
  background-image: url("../assets/branches/BRANCHES.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  filter: grayscale(60%);
}

.card {
  background-color: transparent;
  height: 250px;
}

.card-footer {
  position: absolute;
  bottom: 0;
}

.card-footer.button {
  width: 100%;
}

.maps {
  position: relative;
}

.highlight {
  background-color: #eb272c;
  font-family: inherit;
  color: #fff;
  display: inline-block;
  padding: 3px 5px 5px 5px;
  /* margin-left: -5px; */
  line-height: 1em;
}
.pad-20 {
  padding-bottom: 3em;
}
.location-card {
  background-color: #1b1b1b;
  // width: 300px;
  min-height: 200px !important;
  padding: 1.2em;
  // border-radius: 5px;
  margin: 5px;
}

.map-responsive {
  overflow: hidden;
  padding-bottom: 40%;
  position: relative;
  height: 0;
}
.map-responsive iframe {
  left: 0;
  top: 0;
  height: 40%;
  width: 100%;
  position: absolute;
}

@media only screen and (max-width: 1023px) {
  .map-responsive {
    overflow: hidden;
    padding-bottom: 10%;
    position: relative;
    height: 0;
  }
}
</style>
